import { put, call } from 'redux-saga/effects';
import { createQadraSaga } from './shared';
import { apiAumsGet } from '../api/aum';
import { AUMS_GET } from '../actions/types';

function* aumsGet({ payload: { startDate, endDate } }) {
  const { aums } = yield call(apiAumsGet, { startDate, endDate });
  yield put({
    type: AUMS_GET._SUCCESS,
    payload: { aums },
  });
}

const watchAumsGet = createQadraSaga(aumsGet, {
  action: AUMS_GET._REQUEST,
});

export default [watchAumsGet];
